import * as DatepickerActions from '../actions/datepickers';
import * as FindUserActions from '../actions/findUser';
import * as PaymentsCreators from './paymentsInfo';

import ReduxAction from '../interfaces/ReduxAction';

export function paymentsInfoMountTab (): ReduxAction {
  return (dispatch): void => {
    dispatch(DatepickerActions.fetchDatepickersShowAction());
    dispatch(FindUserActions.fetchActiveTabAction(3));
    dispatch(PaymentsCreators.payments());
  };
}
